import { Theme } from "../../../components/constants";

export default {
	text: { 
		fontSize: "14px", 
		color: Theme.TEXT_PRIMARY_BLACK 
	},
	mainContainer: { 
		display: 'flex', 
		flexDirection: 'column', 
		gap: '20px', 
		marginTop:'10px'
	},
	actionRows: { 
		display: 'flex', 
		justifyContent: 'space-between' 
	},
	searchDiv: { 
		display: 'flex', 
		alignItems: 'center' 
	},
	whiteSpacePre: { 
		whiteSpace: 'pre' 
	},
	actionsColumnButton :{ 
		display: 'flex', 
		gap: '20px' 
	},
	titleRow: { 
		display: 'flex', 
		justifyContent: 'space-between' 
	},
	customPopupStyle: { 
		width: '50vw', 
		maxWidth: '50vw' 
	},
	padding: { 
		padding: '40px' 
	},
	popupBody: { 
		display: 'flex', 
		gap: '20px', 
		alignItems: 'center' 
	},
	fullWidth: { 
		width: '100%' 
	},
	popupActions: { 
		marginTop: '40px', 
		display: 'flex', 
		gap: "20px" 
	}
}